import {
  ArrowRightOutlined,
  CaretRightFilled,
  LoadingOutlined,
  SaveOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import { Button, Col, Modal, Row, Spin } from "antd";
import "./FormLayout.scss";

interface FormLayoutProps {
  translations: any;
  loading: boolean;
  children: any;
  subTitle?: any;
  title: string;
  onClick?: () => void;
  disabledSaveButton?: boolean;
  contractId?: number;
  nextStep?: (idContract: number) => void;
  enableNextStep?: boolean;
  confirm?: any;
  buttonText?: string;
  hideSaveButton?: boolean;
  forceEnableNextStep?: boolean;
}

const FormLayout = (props: FormLayoutProps) => {
  const {
    translations,
    loading,
    children,
    subTitle,
    title,
    onClick,
    disabledSaveButton,
    contractId,
	nextStep,
	enableNextStep,
	confirm,
	buttonText,
  hideSaveButton,
  forceEnableNextStep,
  } = props;

  const confirmModal = () => {
  Modal.confirm({
    title: translations.confirm,
    icon: <ExclamationCircleOutlined />,
    content: confirm,
    okText: translations.si,
    cancelText: translations.no,
	centered: true,
	onOk: () => onClick && onClick()
  });
};

  return (
    <div className="data-wrapper">
      <Spin
        spinning={loading}
        indicator={
          <LoadingOutlined style={{ fontSize: 34, color: "black" }} spin />
        }
      >
		<Row justify="space-between">
          <h2>
            <CaretRightFilled className="caret-green" />
            {title}
          </h2>
		  {nextStep && (
			<Button type="text" className="arrow-btn" onClick={() => nextStep(contractId!)} disabled={!forceEnableNextStep && !enableNextStep}>
				<ArrowRightOutlined />
			</Button>
		  )}
        </Row>
        {subTitle && <p>{subTitle}</p>}
        <Row gutter={[0, 16]} className="data-form-wrapper">
          {children}
        </Row>
        {onClick && !hideSaveButton && (
          <Row justify="end">
            <Col>
              <Button
                type="primary"
                loading={loading}
                onClick={() => confirm ? confirmModal() : onClick()}
                disabled={disabledSaveButton}
                className="saveButton"
              >
                <SaveOutlined />
                {buttonText ?? translations.botonGuardar}
              </Button>
            </Col>
          </Row>
        )}
      </Spin>
    </div>
  );
};

export default FormLayout;
